import * as React from 'react';
import { promiseDelay } from '@webapp/utils/promise-delay';

interface ImageRetryProps
  extends Omit<
    React.DetailedHTMLProps<
      React.ImgHTMLAttributes<HTMLImageElement>,
      HTMLImageElement
    >,
    'src'
  > {
  src?: string;
  setLoading?: (isLoading: boolean) => void;
  handleLoad?: () => void;
}

export const ImageRetry: React.FC<ImageRetryProps> = (props) => {
  const { src: originalSrc, setLoading, handleLoad, ...initProps } = props;
  const [src, setSource] = React.useState<string | undefined>(originalSrc);

  const [retries, setRetries] = React.useState(0);

  React.useEffect(() => {
    setSource(originalSrc);
    if (setLoading) setLoading(true);
  }, [originalSrc, setLoading]);

  if (!src) {
    return null;
  }

  const handleError = async () => {
    if (retries >= 3) {
      return;
    }
    await promiseDelay(500);
    setRetries(retries + 1);
    setSource(`${originalSrc}?_r=${retries}`);
  };

  const onLoad = (_ev: React.SyntheticEvent<HTMLImageElement, Event>) => {
    if (handleLoad) {
      handleLoad();
    }
  };

  const newProps: React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > = {
    ...initProps,
    src,
    onError: handleError,
    onLoad: onLoad,
  };

  return <img {...newProps} alt={props.alt} />;
};
